import { render, staticRenderFns } from "./checklistPlanInfo.vue?vue&type=template&id=0fb65635"
import script from "./checklistPlanInfo.vue?vue&type=script&lang=js"
export * from "./checklistPlanInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0fb65635')) {
      api.createRecord('0fb65635', component.options)
    } else {
      api.reload('0fb65635', component.options)
    }
    module.hot.accept("./checklistPlanInfo.vue?vue&type=template&id=0fb65635", function () {
      api.rerender('0fb65635', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ram/checklist/plan/checklistPlanInfo.vue"
export default component.exports